const state = () => ({
  searchCollections: [],
  searchWineClubs: [],
  searchLinks: [],
  searchExecuting: false,
  searchOpen: false,
  mobileSearchOpen: false,
  results: [],
  count: 0,
  ltoSearchCollections: [],
  ltoSearchWineClubs: [],
  ltoSearchLinks: [],
  ltoSearchExecuting: false,
  ltoSearchOpen: false,
  ltoResults: [],
  ltoCount: 0,
  isSingleCollectionResults: false,
})

async function processSearch($axios, params) {
  const resp = await $axios.get('/api/catalog/search/', { params })
  if (!resp.data || resp.data === 'no data') {
    return {
      count: 0,
      results: [],
      collections: [],
      links: [],
      clubs: [],
    }
  }
  const result = {
    count: resp.data.count || 0,
    results: resp.data.results || [],
    collections: resp.data.collections || [],
    links: [],
    clubs: [],
  }
  if (resp.data.links) {
    result.clubs = resp.data.links.filter(
      (l) => l.collection_type === 'membershiptype',
    )
    result.links = resp.data.links.filter((l) => l.collection_type === 'link')
  }

  return result
}

const mutations = {
  SET_SEARCH_OPEN(state, value) {
    state.searchOpen = value
  },
  SET_MOBILE_SEARCH_OPEN(state, value) {
    state.mobileSearchOpen = value
  },
  CLEAR_SEARCH(state) {
    state.searchCollections = []
    state.searchWineClubs = []
    state.searchLinks = []
    state.searchExecuting = false
    state.searchOpen = false
    state.isSingleCollectionResults = false
    state.results = []
    state.count = 0
  },
  LTO_CLEAR_SEARCH(state) {
    state.ltoSearchCollections = []
    state.ltoSearchWineClubs = []
    state.ltoSearchLinks = []
    state.ltoSearchExecuting = false
    state.ltoResults = []
    state.ltoCount = 0
  },
  SET_IS_SINGLE_COLLECTION_RESULTS(state) {
    state.isSingleCollectionResults = true
  },
  BEFORE_SEARCH(state) {
    state.searchExecuting = true
    state.isSingleCollectionResults = false
  },
  LTO_BEFORE_SEARCH(state) {
    state.ltoSearchExecuting = true
  },
  SET_SEARCH_RESULTS(state, result) {
    state.count = result.count
    state.results = result.results
    state.searchCollections = result.collections
    state.searchWineClubs = result.clubs
    state.searchLinks = result.links
    state.searchExecuting = false
  },
  LTO_SET_SEARCH_RESULTS(state, result) {
    state.ltoCount = result.count
    state.ltoResults = result.results
    state.ltoSearchCollections = result.collections
    state.ltoSearchWineClubs = result.clubs
    state.ltoSearchLinks = result.links
    state.ltoSearchExecuting = false
  },
  LTO_MANUALLY_SET_SEARCH_RESULTS(state, results) {
    state.ltoResults = results || []
  },
}

const actions = {
  setSearchOpen({ commit }, value) {
    commit('SET_SEARCH_OPEN', value)
  },
  setMobileSearchOpen({ commit }, value) {
    commit('SET_MOBILE_SEARCH_OPEN', value)
  },
  clearSearch({ commit }) {
    commit('CLEAR_SEARCH')
  },
  ltoClearSearch({ commit }) {
    commit('LTO_CLEAR_SEARCH')
  },
  async searchAndUpdateState({ commit }, params) {
    const section = params.is_offer ? 'LTO_' : ''
    commit(`${section}BEFORE_SEARCH`)
    let results = await processSearch(this.$axios, params)
    if (results.results.length === 0 && results.collections.length === 1) {
      params = {
        occasions__in: results.collections[0].slug,
      }
      results = await processSearch(this.$axios, params)
      commit('SET_IS_SINGLE_COLLECTION_RESULTS')
    }
    commit(`${section}SET_SEARCH_RESULTS`, results)
  },
  executeSearch({ dispatch, commit }, params) {
    if (params.search.length > 2) {
      dispatch('searchAndUpdateState', params)
      const ltoParams = Object.assign({ is_offer: true }, params)
      dispatch('searchAndUpdateState', ltoParams)
    } else {
      commit('CLEAR_SEARCH')
      commit('LTO_CLEAR_SEARCH')
    }
  },
  ltoExecuteEmptySearch({ dispatch }) {
    const params = {
      is_offer: true,
      page_size: 3,
      page: 1,
    }
    dispatch('searchAndUpdateState', params)
  },
  ltoSetSearchResults({ commit }, searchResults) {
    commit('LTO_MANUALLY_SET_SEARCH_RESULTS', searchResults)
  },
}

const getters = {
  searchCollections(state) {
    return state.searchCollections
  },
  searchWineClubs(state) {
    return state.searchWineClubs
  },
  searchLinks(state) {
    return state.searchLinks
  },
  searchExecuting(state) {
    return state.searchExecuting
  },
  ltoSearchExecuting(state) {
    return state.ltoSearchExecuting
  },
  anySearchExecuting(state) {
    return state.searchExecuting || state.ltoSearchExecuting
  },
  searchOpen(state) {
    return state.searchOpen
  },
  mobileSearchOpen(state) {
    return state.mobileSearchOpen
  },
  results(state) {
    return state.results
  },
  ltoResults(state) {
    return state.ltoResults
  },
  count(state) {
    return state.count
  },
  ltoCount(state) {
    return state.ltoCount
  },
  isOnlyCollectionResults(state) {
    return state.searchCollections?.length > 0 && state.results?.length < 1
  },
  isSingleCollectionResults(state) {
    return state.isSingleCollectionResults
  },
  getStoreSearchUrl:
    (state, getters) =>
    (query, fixedParams, validateResults = true) => {
      let params = '?ordering=-score'
      params = fixedParams ? `${params}&${fixedParams}` : params
      const url = `/store/search/${query}/${params}`

      if (!validateResults) {
        return url
      }

      if (state.isSingleCollectionResults || getters.isOnlyCollectionResults) {
        return state.searchCollections[0].url
      } else if (query && state.results?.length > 0) {
        return url
      }
      return '/store/'
    },
}

export default {
  state,
  mutations,
  actions,
  getters,
}
